// Shared color palette for the dark navy/gold design system used across
// Ask Austrian, the quiz, the nav, and most page chrome. Page-specific accent
// colors (per-explainer highlight colors, etc.) are intentionally not here --
// only values actually repeated across multiple components.
//
// Values are CSS custom properties (defined in index.css), not raw hex, so
// the whole site can respond to prefers-color-scheme from one place. This
// works for both CSS-in-JS template strings (`${theme.gold}`) and inline
// style objects (`style={{ color: theme.gold }}`) since the browser resolves
// var() the same way in either position. It does NOT work for anything fed
// to a <canvas> 2D context (e.g. Chart.js) -- canvas can't resolve CSS
// variables, so chartConfig.js intentionally uses its own literal hex
// instead of importing this file.
export const theme = {
  gold: 'var(--ap-gold)',
  textMuted: 'var(--ap-text-muted)',
  textPrimary: 'var(--ap-text-primary)',
  bgDark: 'var(--ap-bg-dark)',
  bgCard: 'var(--ap-bg-card)',
  error: 'var(--ap-error)',
  success: 'var(--ap-success)',
};

export default theme;
